export enum ProfileEventsEnum {
  RemoveCartEntry = 'RemoveCartEntry',
  UpdateCartEntryQty = 'UpdateCartEntryQty',
  AddToCart = 'AddToCart',
  AboRegistrationStart = 'abo_registration_start',
  CustomerRegistrationStart = 'customer_registration_start',
  MemberRegistrationStart = 'member_registration_start',
  CustomerRegistrationComplete = 'customer_registration_complete',
  AboRegistrationComplete = 'abo_registration_complete',
  MemberRegistrationComplete = 'member_registration_complete',
}
export const enum InternationalSponsorTypeEnum {
  INTERNATIONAL = 'international',
  MULTIPLE_BUSINESS = 'multiple',
}
export enum AccountyTypeEnum {
  CUSTOMER = 'MEMBER',
  BUSINESS_OWNER = 'BUSINESS_OWNER',
}
export enum ProgressiveProfileNextStepEnum {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
}
export enum AccountProcessType {
  Registration = 'REGISTRATION',
  Renewal = 'RENEWAL',
  Upgrade = 'UPGRADE',
  Downgrade = 'DOWNGRADE',
}
export enum RoutePaths {
  CHECKOUT = '/checkout',
  DASHBOARD = '/my-account',
  PROFILE = '/my-account/personal-information',
  ACCOUNT_INFORMATION = '/my-account/account-renewals',
  AUTO_RENEWAL = '/my-account/account-renewals/auto-renewal',
  AUTO_RENEWAL_CONFIRMATION = '/my-account/account-renewals/auto-renewal/confirmation',
  MY_SHIPPING_ADDRESS = '/my-account/shipping-address',
  MY_SHIPPING_ADDRESS_ADD_NEW = '/my-account/shipping-address/add',
  MY_SHIPPING_ADDRESS_EDIT = '/my-account/shipping-address/edit',
  SIGN_UP = '/signup',
  HOME = '/',
  CART = '/cart',
  ORDER_HISTORY = '/order-history',
  PERSONAL_INFORMATION = '/my-account/personal-information?showEdit=true',
}

export enum PhoneDisplayTypeEnum {
  NATIONAL = 'NATIONAL',
  INTERNATIONAL = 'INTERNATIONAL',
}

export const PaymentStatus = {
  INITIATED: 'INITIATED',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
  INITIATED_FAILED: 'INITIATED_FAILED',
  CARD_EXPIRED: 'CARD_EXPIRED',
};

export enum RenewalPeriodTypeEnum {
  EXPIRY_DATE = 'expiryDate',
  FIXED_MONTH = 'fixedMonth',
}

export enum DeliveryOption {
  STANDARD = 'STANDARD',
  DELUXE = 'DELUXE',
  SELF = 'SELF COLLECTION',
}

export enum AutoRenewalDeliveryTypeEnum {
  EKIT = 'EM',
  HOME_DELIVERY = 'AD',
  PICKUP = 'PK',
}

export enum SubscriptionPaymentMethodEnum {
  CREDIT_CARD = 'CreditCard',
  BANK_SAVING = 'Saving',
  BANK_CURRENT = 'Current',
}

export enum ContractTypeEnum {
  CONTRACTS = 'contracts',
  DOCUMENTS = 'documents',
}

export enum ExternalContactType {
  // For other POD
  BillingCheckout = 'BILLING_CHECKOUT',
}

export default ProfileEventsEnum;
